import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import {
    Users, FileText, Euro, Award, BarChart2, Download,
    ChevronDown, Loader2, FileDown
} from 'lucide-react';

export default function AgencyQuickActions({
    navigate,
    handleGenerateReport,
    handleExport,
    generatingReport,
    exporting,
    reportMenuOpen,
    setReportMenuOpen,
    exportMenuOpen,
    setExportMenuOpen
}) {
    return (
        <div className="hidden sm:grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
            <Card
                className="bg-gradient-to-br from-purple-900/50 to-purple-800/30 border-purple-500/20 hover:border-purple-500/40 transition-colors cursor-pointer"
                onClick={() => navigate('/admin/team')}
                data-testid="certifications-card"
            >
                <CardContent className="p-4">
                    <div className="flex items-center gap-3">
                        <Award className="w-8 h-8 text-purple-400" />
                        <div>
                            <h3 className="font-semibold text-foreground">Certifications</h3>
                            <p className="text-sm text-muted-foreground">Voir les certifications des agents</p>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Reports Card */}
            <div className="relative">
                <Card
                    className="bg-gradient-to-br from-blue-900/50 to-blue-800/30 border-blue-500/20 hover:border-blue-500/40 transition-colors cursor-pointer"
                    onClick={() => setReportMenuOpen(!reportMenuOpen)}
                    data-testid="reports-pdf-card"
                >
                    <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                {generatingReport ? <Loader2 className="w-8 h-8 text-blue-400 animate-spin" /> : <FileDown className="w-8 h-8 text-blue-400" />}
                                <div>
                                    <h3 className="font-semibold text-foreground">Rapports PDF</h3>
                                    <p className="text-sm text-muted-foreground">Générer des rapports</p>
                                </div>
                            </div>
                            <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform ${reportMenuOpen ? 'rotate-180' : ''}`} />
                        </div>
                    </CardContent>
                </Card>
                {reportMenuOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-xl z-50 overflow-hidden"
                    >
                        <button onClick={handleGenerateReport} className="w-full px-4 py-3 text-left text-foreground hover:bg-muted flex items-center gap-3 transition-colors" data-testid="generate-agency-report">
                            <BarChart2 className="w-4 h-4 text-[#681793]" />
                            <span>Bilan mensuel (Tableau + Analyse IA)</span>
                        </button>
                    </motion.div>
                )}
            </div>

            {/* Export Card */}
            <div className="relative">
                <Card
                    className="bg-gradient-to-br from-green-900/50 to-green-800/30 border-green-500/20 hover:border-green-500/40 transition-colors cursor-pointer"
                    onClick={() => setExportMenuOpen(!exportMenuOpen)}
                    data-testid="export-csv-card"
                >
                    <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                {exporting ? <Loader2 className="w-8 h-8 text-green-400 animate-spin" /> : <Download className="w-8 h-8 text-green-400" />}
                                <div>
                                    <h3 className="font-semibold text-foreground">Export CSV</h3>
                                    <p className="text-sm text-muted-foreground">Exporter les données</p>
                                </div>
                            </div>
                            <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform ${exportMenuOpen ? 'rotate-180' : ''}`} />
                        </div>
                    </CardContent>
                </Card>
                {exportMenuOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-xl z-50 overflow-hidden"
                    >
                        {[
                            { type: 'agents', icon: Users, color: 'text-blue-400', label: 'Exporter les agents' },
                            { type: 'mandates', icon: FileText, color: 'text-purple-400', label: 'Exporter les mandats' },
                            { type: 'offers', icon: Euro, color: 'text-green-400', label: 'Exporter les offres' },
                            { type: 'activity', icon: BarChart2, color: 'text-orange-400', label: "Rapport d'activité", border: true },
                        ].map(item => (
                            <button
                                key={item.type}
                                onClick={() => handleExport(item.type)}
                                className={`w-full px-4 py-3 text-left text-foreground hover:bg-muted flex items-center gap-3 transition-colors ${item.border ? 'border-t border-border' : ''}`}
                                data-testid={`export-${item.type}`}
                            >
                                <item.icon className={`w-4 h-4 ${item.color}`} />
                                <span>{item.label}</span>
                            </button>
                        ))}
                    </motion.div>
                )}
            </div>
        </div>
    );
}
